<template>
  <app-modal
    v-if="show"
    :maxWidth="maxWidth"
    :maxHeight="maxHeight"
    :isClickMaskClose="false"
    @close="hideModal"
  >
    <el-form
      class="attr-coordinate-form"
      ref="coordinateForm"
      :rules="rules"
      :model="coord"
    >
      <h3 class="attr-coordinate-form__title">
        {{ title }}
      </h3>

      <el-form-item
        class="attr-coordinate-form__item"
        :label="$t('attr_value_coord_lat')"
        prop="lat"
      >
        <el-input-number
          v-model="coord.lat"
          :precision="precision"
          :step="step"
          :min="latMinValue"
          :max="latMaxValue"
          autofocus
        ></el-input-number>
      </el-form-item>

      <el-form-item
        class="attr-coordinate-form__item"
        :label="$t('attr_value_coord_lng')"
        prop="lng"
      >
        <el-input-number
          v-model="coord.lng"
          :precision="precision"
          :step="step"
          :min="longMinValue"
          :max="longMaxValue"
        ></el-input-number>
      </el-form-item>

      <el-form-item
        class="attr-coordinate-form__item"
        :label="$t('attr_value_coord_text')"
      >
        <el-input v-model="text" @change="textToCoord"></el-input>
      </el-form-item>

      <el-form-item
        class="attr-coordinate-form__item attr-coordinate-form__action"
      >
        <el-button @click="hideModal">
          {{ $t("attr_value_coord_cancel") }}
        </el-button>

        <el-button type="success" @click="submitForm('coordinateForm')">
          {{ $t("attr_value_coord_save") }}
        </el-button>
      </el-form-item>
    </el-form>
  </app-modal>
</template>

<script>
export default {
  name: "AttributeValueCoordinate",
  components: {
    AppModal: () =>
      import(
        /* webpackChunkName: "appModal" */ "@/components/library.blocks/AppModal.vue"
      )
  },
  props: {
    maxWidth: {
      type: String,
      default: "100%"
    },
    maxHeight: {
      type: String,
      default: "100%"
    },
    show: {
      type: Boolean,
      default: false
    },
    title: String,
    complexValue: Object
  },
  data() {
    return {
      precision: 6,
      step: 0.1,
      coord: {
        lat: "",
        lng: ""
      },
      rules: {
        lat: [
          {
            required: true,
            message: this.$t("attr_value_coord_lat_rule"),
            trigger: "change"
          }
        ],
        lng: [
          {
            required: true,
            message: this.$t("attr_value_coord_lng_rule"),
            trigger: "change"
          }
        ]
      },
      latMinValue: -90,
      latMaxValue: 90,
      longMinValue: -180,
      longMaxValue: 180,
      text: ""
    };
  },
  computed: {},
  methods: {
    hideModal() {
      this.$emit("close");
    },
    save() {
      this.$emit("save", this.coord);
    },
    setText() {
      if (this.complexValue && this.complexValue.coordinate) {
        this.coord = this.complexValue.coordinate;
      }
    },
    reset() {
      this.coord = {
        lat: "",
        lng: ""
      };
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save();
          this.reset();
          this.hideModal();
        } else {
          return false;
        }
      });
    },
    textToCoord(val) {
      let strArr = val.split(",");
      if (strArr.length === 2) {
        let lat = parseFloat(strArr[0]);
        let lng = parseFloat(strArr[1]);
        if (lat && lng) {
          this.coord = {
            lat,
            lng
          };
        }
      }
    },
    setTextCoord() {
      let lat = (this.coord.lat || 0).toFixed(6);
      let lng = (this.coord.lng || 0).toFixed(6);
      this.text = `${lat}, ${lng}`;
    }
  },
  mounted() {
    this.setText();
  },
  watch: {
    complexValue: function () {
      this.setText();
    },
    coord: {
      handler: function () {
        this.setTextCoord();
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
@import "@/css/variables.scss";

.attr-coordinate {
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
}
.attr-coordinate-form {
  .attr-coordinate-form__title {
    text-align: left;
    padding: $form_title_padding;
  }

  .attr-coordinate-form__item {
    padding: $form_item_padding;
  }

  .attr-coordinate-form__action {
    text-align: right;
  }
}
</style>
